import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { InputmaskOptions } from '@ngneat/input-mask';
import AirDatepicker from 'air-datepicker';
import localeEs from 'air-datepicker/locale/es';
import { debounceTime } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-input-field-maker',
  templateUrl: './input-field-maker.component.html',
  styleUrls: ['./input-field-maker.component.scss']
})
export class InputFieldMakerComponent implements OnChanges {

  // Events
  @Output() onChangeEvent = new EventEmitter<any>();
  @Output() onInputEvent = new EventEmitter<any>();
  @Output() onInputUrlEvent = new EventEmitter<any>();

  @Output() blur = new EventEmitter<any>();

  // General
  @Input() inputType: string = "text";
  @Input() controlName!: string;
  @Input() formGroup!: FormGroup<any>
  @Input() label: string = "";
  @Input() disabled: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() generalError: string = '';
  @Input() showError: boolean = true;

  // Html Input
  @Input() autoComplete: boolean = false;
  @Input() required: boolean = false;
  @Input() spellCheck: boolean = true;
  @Input() icon: string = '';
  @Input() iconPos: string = 'right';

  // NgSelect
  @Input() items: any[] = [];
  @Input() multiple: boolean = false;
  @Input() bindLabel: string = '';
  @Input() bindValue: string = '';
  @Input() minDate: Date | undefined;

  // Mask
  @Input() inputMask!: InputmaskOptions<any> | null;

  // Date
  @Input() timepicker: boolean = false;

  inputSignature!: string;

  constructor(
    private cdr: ChangeDetectorRef
  ) {
    this.inputSignature = `input-${this.controlName}-${uuidv4()}`;

  }

  ngAfterViewInit(): void { 
    if (this.inputType == 'date') {
      let initialDate: any = '';
      if (this.formGroup.get(this.controlName)?.value) {
        // Suponiendo que this.value es una cadena en formato 'DD/MM/YYYY HH:MM AA'
        let dateTimeParts = this.formGroup.get(this.controlName)?.value.split(' '); // Separa la fecha de la hora y AM/PM
        let dateParts = dateTimeParts[0].split('/'); // Separa la fecha en día, mes, año
        let timeParts = dateTimeParts[1].split(':'); // Separa la hora y minutos
        let amPm = dateTimeParts[2]; // AM o PM
        let hour = parseInt(timeParts[0], 10);
        let minute = parseInt(timeParts[1], 10);
      
        // Convierte las horas a formato 24 horas si es necesario
        if (amPm === 'PM' && hour < 12) {
          hour += 12;
        } else if (amPm === 'AM' && hour === 12) {
          hour = 0;
        }
      
        // Verifica si la longitud del arreglo de fecha es 3 (día, mes, año)
        if (dateParts.length === 3) {
          let day = parseInt(dateParts[0], 10);
          let month = parseInt(dateParts[1], 10) - 1; // Los meses en JavaScript son 0-indexados
          let year = parseInt(dateParts[2], 10);
      
          // Verifica si los números son válidos y si la fecha y hora son válidas
          if (!isNaN(day) && !isNaN(month) && !isNaN(year) && !isNaN(hour) && !isNaN(minute) && month >= 0 && month < 12) {
            initialDate = new Date(year, month, day, hour, minute);
          }
        }
      }
      new AirDatepicker(`#${this.inputSignature}`, {
        locale: localeEs,
        timepicker: this.timepicker,
        timeFormat: 'hh:mm AA',
        buttons: ['today', 'clear'],
        selectedDates: [initialDate], // Inicializa con un valor de fecha
        minDate: this.minDate, // Set minDate to today's date
        onSelect: (e: any) => {
          this.formGroup.controls[this.controlName].patchValue(e.formattedDate);
          //this.cdr.detectChanges();
        }
      });
    } else if (this.inputType == 'url') {
      this.formGroup.get(this.controlName)?.valueChanges
        .pipe(
          debounceTime(1000), // Espera 1 segundo después de que el usuario deja de escribir
        )
        .subscribe((value) => {
          if (['url'].includes(this.inputType)) {
            let valueFilter = this.formGroup.get(this.controlName)?.value;
            if(valueFilter){ 
              valueFilter = valueFilter.replace(/\s+/g, '-')
                .replace(/[^a-z0-9-]/g, '')
              this.onInputUrlEvent.emit(valueFilter);
            } 
          }
        })
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.inputType == 'date' && this.minDate != undefined && changes['minDate']) {
      new AirDatepicker(`#${this.inputSignature}`, {
        locale: localeEs,
        timepicker: this.timepicker,
        timeFormat: 'hh:mm AA',
        buttons: ['today', 'clear'],
        minDate: this.minDate, // Set minDate to today's date
        onSelect: (e: any) => {
          this.formGroup.controls[this.controlName].patchValue(e.formattedDate);
          //this.cdr.detectChanges();
        }
      });
    }
  }

  onChange($event: any) {
    this.onChangeEvent.emit($event.target.value);
  }

  onNgSelectChange($event: any) {
    this.onChangeEvent.emit($event);
  }

  onInput($event: any) {
    this.onInputEvent.emit($event.target.value);
  }
  disableScroll(event: any, inputElement: HTMLInputElement, inputType: string) {
    if (document.activeElement === inputElement && inputType === 'number') {
      event.preventDefault();
    }
  }

  esRequerido(): boolean {
    const control = this.formGroup.get(this.controlName);
    if (!control || !control.validator) return false;

    const validator = control.validator({} as AbstractControl);
    return (validator && validator['required']) ? true : false;
  }
  blurEvent($event: any) {
    this.blur.emit($event);
  }


}
